import { publishedCases, RUBROS, localizeCase } from "./caseStudies";
import { CASE_PREFIX, type Locale } from "../i18n/config";

/**
 * Casos para el carrusel de la home. Derivan del modelo unico de casos y cada
 * uno apunta a su vista individual (/caso/<slug> o /en/case/<slug>).
 */
export interface FeaturedCase {
  id: string;
  category: string;
  logo?: string;
  logoAlt?: string;
  logoBadge?: boolean;
  brand?: string;
  client: string;
  summary: string;
  href: string;
}

export function getFeaturedCases(locale: Locale): FeaturedCase[] {
  return publishedCases.map((c) => {
    const localized = localizeCase(c, locale);
    return {
      id: c.slug,
      category: locale === "en" ? RUBROS[c.rubro].labelEn : RUBROS[c.rubro].label,
      logo: c.logo,
      logoAlt: c.logoAlt,
      logoBadge: c.logoBadge,
      brand: c.brand,
      client: c.client,
      summary: localized.summary,
      href: `${CASE_PREFIX[locale]}/${c.slug}`,
    };
  });
}
